import React, { useContext, useEffect } from 'react'
import AnellLogo from '../../../assets/Anell.png'
import Navbar from '../../../components/Navbar/Navbar'
import TopBar from '../../../components/TopBar/TopBar'
import {BiSolidUser} from "react-icons/bi"
import {GiPadlock} from "react-icons/gi"
import './LoginPage.scss'
import { RotatingLines } from 'react-loader-spinner'
import AuthContext from '../../../context/authContext'

const LoginPage = () => {
    
    const {loginUser, loggingIn, user} = useContext(AuthContext)
    useEffect(() => {
        if(user){
            window.location.href = "/dashboard"
        }
    }, [user])
    
  return (
    <div>
        <TopBar />
        <Navbar />
        <div id="login-page">
            <div className="login-section">
                <div className="school-logo">
                    <img src={AnellLogo} alt="anell" />
                    <div className="school-name">
                        <div className="school-main-name">
                            <h2 className="anell">
                                Anell
                            </h2>
                            <span className="school-of-excellence">
                                <p>SCHOOL OF</p>
                                <p>EXCELLENCE</p>
                            </span>
                        </div>
                        <p className="school-motto">
                            ...excel and lead!!!
                        </p>
                    </div>
                    <div className="logo-underline"></div>
                </div>
                <form onSubmit={loginUser} className="login-form">
                    <div className="input-container">
                        <BiSolidUser />
                        <input type="text" name="username" id="username" placeholder='Username' required />
                    </div>
                    <div className="input-container">
                        <GiPadlock />
                        <input type="password" name="password" id="password" placeholder='Password' required />
                    </div>
                    {
                        loggingIn ? (
                            <div className='rotating-lines'>
                                <RotatingLines
                                strokeColor="#021D53"
                                strokeWidth="5"
                                animationDuration="0.75"
                                width="26"
                                visible={true}
                                />
                            </div>
                        ):(
                            <input type="submit" value="LOG IN" />
                        )
                    }
                </form>
            </div>
        </div>
    </div>
  )
}

export default LoginPage